export default "__VITE_ASSET__Gz$V$WE1__"